import { render, staticRenderFns } from "./anKang.vue?vue&type=template&id=bbb77a24&scoped=true&"
import script from "./anKang.vue?vue&type=script&lang=js&"
export * from "./anKang.vue?vue&type=script&lang=js&"
import style0 from "./anKang.vue?vue&type=style&index=0&id=bbb77a24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb77a24",
  null
  
)

export default component.exports